export default {
      id: "svg-icon-icoX-usage",
      viewBox: "0 0 14.849 14.849",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-icoX",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/icoX.svg
// module id = XXeK
// module chunks = 4